var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.checkRoles(_vm.roles.admins)),expression:"$auth.checkRoles(roles.admins)"}],staticClass:"vx-col w-full lg:w-1/3 mb-base"},[_c('admin')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }